import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TopicCardModel } from '../../../models/topic-card.model';

@Component({
  selector: 'app-topic-card',
  templateUrl: './topic-card.component.html',
  styleUrl: './topic-card.component.scss',
  standalone: false,
})
export class TopicCardComponent {
  @Input() topicCard: TopicCardModel;
  @Output() buttonClicked = new EventEmitter<void>();

  onClick() {
    this.buttonClicked.emit();
  }
}
